module.exports = __webpack_public_path__ + "img/btt.1b7e97fb.svg";